import React, {memo} from "../../../__snowpack__/pkg/react.js";
import {Popover, Image} from "../../../__snowpack__/pkg/antd.js";
import {IconEmptyimage} from "../../../__snowpack__/pkg/@genieui-react/icon.js";
export const PopoverImg = memo((props) => {
  const {placement, popoverAvatarSize, avatarSize = 64, previewImage} = props;
  const IconEmptyimageFunc = (size) => {
    return /* @__PURE__ */ React.createElement(IconEmptyimage, {
      style: {
        width: size,
        height: size
      }
    });
  };
  return !previewImage ? IconEmptyimageFunc(avatarSize) : /* @__PURE__ */ React.createElement(Popover, {
    placement: placement || "right",
    content: /* @__PURE__ */ React.createElement(Image, {
      width: popoverAvatarSize || 300,
      height: popoverAvatarSize || 300,
      src: previewImage || IconEmptyimageFunc(popoverAvatarSize),
      preview: false,
      loading: "lazy"
    })
  }, /* @__PURE__ */ React.createElement(Image, {
    width: avatarSize,
    height: avatarSize,
    src: previewImage,
    preview: false,
    loading: "lazy",
    placeholder: IconEmptyimageFunc(avatarSize)
  }));
});
